export default __webpack_public_path__ + "static/media/filter.54dc84b8.svg";